// @flow

import React from 'react';

import {
  EvenlySpacedImageList,
  BlockyModalVideoPlayer,
  BlockyText,
  BlockyCardList,
  BlockyComparisonList,
  BlockyTrustpilotTestimonialCarousel,
} from 'components/Content';
import { ImageContainer } from 'components/Gui';

type Props = {
  contentType:
    | EvenlySpacedImageList.contentType
    | BlockyModalVideoPlayer.contentType
    | BlockyText.contentType
    | BlockyCardList.contentType
    | BlockyComparisonList.contentType
    | BlockyTrustpilotTestimonialCarousel.contentType
    | ImageContainer.contentType,
  config: any,
};

const BlockyContentItems = ({ contentType, config, ...rest }: Props) => (
  <>
    {(() => {
      switch (contentType) {
        case ImageContainer.contentType:
          return <ImageContainer {...config} {...rest} />;
        case BlockyTrustpilotTestimonialCarousel.contentType:
          return <BlockyTrustpilotTestimonialCarousel {...config} {...rest} />;
        case BlockyComparisonList.contentType:
          return <BlockyComparisonList {...config} {...rest} />;
        case BlockyCardList.contentType:
          return <BlockyCardList {...config} {...rest} />;
        case EvenlySpacedImageList.contentType:
          return <EvenlySpacedImageList {...config} {...rest} />;
        case BlockyText.contentType:
          return <BlockyText {...config} {...rest} />;
        case BlockyModalVideoPlayer.contentType:
          return <BlockyModalVideoPlayer {...config} {...rest} />;
        default:
          return null;
      }
    })()}
  </>
);

export default BlockyContentItems;
